import type { LocalizedString } from '@/types';

const INCIDENT_TEXT_LOCALES = {
  en: 'en',
  de: 'de',
} as const;

type IncidentLang = keyof LocalizedString;

const getIncidentLanguage = (language: string): IncidentLang =>
  (INCIDENT_TEXT_LOCALES[language as keyof typeof INCIDENT_TEXT_LOCALES] ?? 'en') as IncidentLang;

export default getIncidentLanguage;
